import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { LeadsService } from '../services/lead-service/lead-service.service';
import { ErrorHandlerService } from '../services/shared/error-handler.service';
import swal from 'sweetalert2';
import { isFutureDateTime } from '../shared/object_helpers';
import { HelpdeskService } from '../services/helpdesk/helpdesk.service';
import { TeamService } from '../services/settings-service/team/team.service';

@Component({
  selector: 'app-todos',
  templateUrl: './todos.component.html',
  styleUrls: ['./todos.component.css']
})
export class TodosComponent implements OnInit {
  labels = ['meeting', 'call', 'message'];
  assignees: 'only_me' | 'only_others' | 'custom_users' | null = null;
  selectedTeamsType: 'all' | 'custom_teams' | null = null;
  due_type: 'all' | 'late' | 'today' | 'tomorrow' | 'upcoming' | 'complete' | null = 'all';
  page_size: number = 10;
  total: number = 0;
  page: number = 1;
  last_page: number = 0;
  date_from: string = null;
  date_to: string = null;
  leadActions: any[] = [];
  action_type: string = 'meeting';
  leadDetails: any;
  firstAction: any;
  todoItem: any;
  params: any = {
    action_type: this.action_type,
    page: this.page,
    per_page: this.page_size
  };
  reminder: any = {
    lead_action_id: null,
    title: null,
    details: null,
    reminder_datetime: null,
  };
  nextAction: any = {
    next_action: null,
    next_action_meeting_type_id: null,
    next_action_due_date: null,
    next_action_event_type_id: null,
    next_action_event_status_id: null,
    next_action_call_type_id: null,
    next_action_message_source_id: null,
    next_action_feedback_status_id: null,
    next_action_feedback: null,
    next_action_status: null,
    next_action_notes: null
  };
  feedback: any = {
    action_type: "feedback",
    feedback_status_id: null,
    meeting_type_id: null,
    note: null,
    has_next_action: false
  };
  nextActions: string[] = ["meeting", "call", "message"];
  meetingTypes: any;
  eventTypes: any;
  eventStatuses: any;
  callTypes: any;
  messageSources: any;
  feedbackStatuses: any;
  filteredFeedbackStatuses: any;
  users_ids: any;
  teams_ids: any;
  users: any[] = [];
  teams: any[] = [];
  feedbackStatusFilterId: number = null;

  constructor(
    private router: Router,
    private teamService: TeamService,
    private leadsService: LeadsService,
    private helpdeskService: HelpdeskService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
  ) { }

  ngOnInit() {
    this.getUsers();
    this.getTeams();
    this.getMeetingTypes();
    this.getEventTypes();
    this.getEventStatuses();
    this.getCallTypes();
    this.getMessageSources();
    this.getFeedbackStatuses();
    this.filterByDueDate('all');
  }

  getTeams() {
    this.teamService.getTeams().subscribe((res: any) => {
      this.teams = res.data;
    }, (err) => {
      this.errorHandlerService.handleErorr(err);
    })
  }

  getUsers() {
    this.slimLoadingBarService.start();
    this.leadsService.getAgents().subscribe((res: any) => {
      this.users = res;
      this.slimLoadingBarService.complete();
    }, (err) => {
      this.slimLoadingBarService.complete();
      this.errorHandlerService.handleErorr(err);
    })
  }

  getLeadActions(params?: any) {
    this.slimLoadingBarService.start();
    this.leadsService.getLeadActions(params).subscribe((res: any) => {
      this.leadActions = res.actions.data;
      this.total = res.actions.total;
      this.last_page = res.actions.last_page;
      this.page = res.actions.current_page;
      const perPage = Number(res.actions.per_page);
      this.page_size = Number.isNaN(perPage) ? this.page_size : perPage;
      this.slimLoadingBarService.complete();
    }, (err) => {
      this.slimLoadingBarService.complete();
      this.errorHandlerService.handleErorr(err);
    })
  }


  getMeetingTypes() {
    this.helpdeskService.getMeetingTypes().subscribe(
      (res: any) => {
        this.meetingTypes = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getEventTypes() {
    this.helpdeskService.getEventTypes().subscribe(
      (res: any) => {
        this.eventTypes = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getEventStatuses() {
    this.helpdeskService.getEventStatuses().subscribe(
      (res: any) => {
        this.eventStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getCallTypes() {
    this.helpdeskService.getCallTypes().subscribe((res: any) => {
      this.callTypes = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }

  getMessageSources() {
    this.helpdeskService.getMessageSources().subscribe((res: any) => {
      this.messageSources = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }

  getFeedbackStatuses() {
    this.helpdeskService.getFeedbackStatuses().subscribe((res: any) => {
      res.forEach((status) => {
        status.action_type ? status.action_type : status.action_type = [];
        if (typeof status.action_type === 'string') {
          status.action_type = JSON.parse(status.action_type);
        }
      })
      console.log(res);
      this.feedbackStatuses = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }

  filterByDueDate(due_type) {
    this.params.page = 1; // Reset to first page when filtering
    this.due_type = due_type;
    this.params.due_type = due_type;
    console.log(this.params);
    this.getLeadActions(this.params);
  }

  onPageSizeChange(page_size) {
    if (page_size != this.params.per_page) {
      this.params.page = 1;
      this.params.per_page = page_size;
      this.params.due_type = this.due_type;
      this.params.assignees = this.assignees;
      this.params.action_type = this.action_type;
      this.getLeadActions(this.params);
    }
  }

  filterByAssignees(assignee_type: 'only_me' | 'only_others' | 'custom_users' | null) {
    this.params.page = 1; // Reset to first page when filtering
    this.assignees = assignee_type;
    this.params.assignees = assignee_type;
    this.params['users_ids[]'] = this.users_ids;
    
    this.getLeadActions(this.params);
  }

  filterByTeams(teams_type: 'all' | 'custom_teams' | null) {
    this.params.page = 1; // Reset to first page when filtering
    this.selectedTeamsType = teams_type;
    this.params['teams_ids[]'] = this.teams_ids;
    this.getLeadActions(this.params);
  }

  applyDateFilter() {
    const hasFrom = !!this.date_from;
    const hasTo = !!this.date_to;

    if (hasFrom && hasTo && new Date(this.date_from) > new Date(this.date_to)) {
      swal("Oops...", "Start date can't be after end date", "error");
      return;
    }

    this.params.page = 1;
    this.params.date_from = this.date_from;
    this.params.date_to = this.date_to;

    this.getLeadActions(this.params);
  }

  clearDateFilter() {
    if (!this.date_from && !this.date_to) {
      return;
    }

    this.date_from = null;
    this.date_to = null;
    delete this.params.date_from;
    delete this.params.date_to;
    this.params.page = 1;
    this.getLeadActions(this.params);
  }

  onTabChange(index: number) {
    this.params.page = 1; // Reset to first page when changing tabs
    let label = this.labels[index] !== undefined ? this.labels[index] : 'Tab ' + index;
    this.action_type = label;
    this.params.action_type = label;
    this.getLeadActions(this.params);
  }

  addReminder() {
    this.slimLoadingBarService.start();
    const data = {
      title: this.reminder.title,
      details: this.reminder.details,
      lead_action_id: this.reminder.lead_action_id,
      reminder_datetime: this.reminder.reminder_datetime,
    };
    console.log(data);
    this.leadsService.addLeadReminder(this.leadDetails["id"], data).subscribe(
      (res) => {
        this.reminder = {
          title: null,
          details: null,
          lead_action_id: null,
          reminder_datetime: null,
        };
        this.slimLoadingBarService.complete();
        swal("Woohoo!", "Reminder created succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  private toLocalDatetimeLocal(isoOrDate: string | Date): string {
    const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
    // HTML datetime-local ignores seconds; trim them for cleanliness
    d.setSeconds(0, 0);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  nextActionModalOpen() {
    const existing = new Date();
    this.nextAction = this.nextAction || {};
    this.nextAction.due_type = this.toLocalDatetimeLocal(existing);
  }

  setActionModalSubmit(modal: any, nextActionModal: any, modalData: any, has_first_action?: boolean) {
    let payload;
    if (has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      payload.lead_action_id = this.todoItem.id
      this.leadsService.addFeedback(this.leadDetails["id"], payload).subscribe(
        (res: any) => {
          modal.close();
          swal(res.message, "", "success");
          console.log(isFutureDateTime(payload.due_type))
          if (isFutureDateTime(payload.due_type)) {
            this.reminder.title = payload.action_type;
            this.reminder.lead_action_id = res.lead_action.id
            this.reminder.details = payload.notes;
            this.reminder.reminder_datetime = payload.due_type;
            this.addReminder();
          }
          this.filterByDueDate('late');
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
    }
  }

  filterFeedbackStatuses(action_type: string) {
    this.filteredFeedbackStatuses = this.feedbackStatuses
    this.filteredFeedbackStatuses = this.filteredFeedbackStatuses.filter((status: any) => status.action_type.includes(action_type));
  }

  filterByFeedbackStatus(statusId: number) {
    this.params.page = 1;
    this.feedbackStatusFilterId = statusId;

    if (statusId) {
      this.params.feedback_status_id = statusId;
    } else {
      delete this.params.feedback_status_id;
    }

    this.getLeadActions(this.params);
  }

  nextPage() {
    if (this.page < this.last_page) {
      this.page++;
      let params = {
        ...this.params,
        due_type: this.due_type,
        page: this.page
      };
      this.getLeadActions(params);
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
      let params = {
        ...this.params,
        due_type: this.due_type,
        page: this.page
      };
      this.getLeadActions(params);
    }
  }

  goToPage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.last_page) {
      this.page = pageNumber;
      let params = {
        ...this.params,
        due_type: this.due_type,
        page: this.page
      };
      this.getLeadActions(params);
    }
  }

  navigateToLead(leadId: number) {
    this.router.navigate(['/pages/leads'], { queryParams: { lead_id: leadId } });
  }
}



// WEBPACK FOOTER //
// ./src/app/todos/todos.component.ts